import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrepaidWashBook } from '../../models/prepaid-wash-book.models';
import { ConfirmActionModalComponent } from '../../shared/components/confirm-action-modal';

@Component({
  selector: 'app-delete-prepaid-wash-book-modal',
  standalone: true,
  imports: [CommonModule, ConfirmActionModalComponent],
  templateUrl: './delete-prepaid-wash-book-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./delete-prepaid-wash-book-modal.component.scss'],
})
export class DeletePrepaidWashBookModalComponent {
  @Input() book: PrepaidWashBook | null = null;
  @Input() loading = false;
  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<PrepaidWashBook>();

  onClose(): void {
    if (!this.loading) {
      this.close.emit();
    }
  }

  onConfirm(): void {
    if (this.book && !this.loading) {
      this.confirm.emit(this.book);
    }
  }
}
